'use strict';

require('./password.base.field.css');

export default class PasswordBaseFieldComponent {
  constructor() {
    this.restrict = 'E';
    this.template = require('./password.base.field.html');
    this.scope = {
      field: '=',
      isDerivedFromTemplate: '='
    };
    this.controller = PasswordBaseFieldController;
    this.controllerAs = 'ctrl';
    this.bindToController = true;
  }
}


/* @ngInject */
class PasswordBaseFieldController {
  constructor() {}
}
